import React from "react";

export const FormPanel: React.FC<{ label: string }> = ({ children, label }) => (
  <div className="border-2 border-grey-10 md:border-0 px-5 py-6 md:p-0 md:mb-10 text-s font-semibold mb-3 md:last:mb-0 rounded">
    <h2 className="mb-5 md:text-base">{label}</h2>
    {children}
  </div>
);
